import { useMutation } from 'react-query';

import { updateSubGroup } from 'shared/api/business-units/http';

const useMutateUpdateSubGroup = (options = undefined) =>
  useMutation(({ id, subGroup }) => updateSubGroup(id, subGroup), options);

export default useMutateUpdateSubGroup;
